document.addEventListener('DOMContentLoaded', main);

// Main
function main() {
  window.LocationsSection = LocationsSection();

  // check for search params and open corresponding tab, if present
  const searchParams = new URLSearchParams(window.location.search);

  for (const param of searchParams) {
    if (param[0] === 'location') {
      try {
        const locationName = param[1].replaceAll("_", "-");
        const tab = document.querySelector(`[data-info="${locationName}"]`);
        if (tab) tab.click();
      } catch (e) {
        // unable to automatically open location tab, do nothing
      }
    }
  }

  // check for global locationHandle if it exists
  try {
    if (typeof locationHandle !== 'undefined' && locationHandle !== '') {
      const tab = document.querySelector(`[data-info="${locationHandle}"]`);
      if (tab) tab.click();
    }
  } catch (e) {
    // not able to open
  }

  // check the last part of the pathname (e.g., /showroom-locations/dallas)
  const pathParts = window.location.pathname.split("/").filter(Boolean);
  const lastPart = pathParts[pathParts.length - 1]; // "dallas"

  if (lastPart && lastPart !== "showroom-locations") {
    const tab = document.querySelector(`[data-info="${lastPart}"]`);
    if (tab) {
      tab.click(); // will run swiper init via clickHandler
    }
  }

  // Initialize Swiper on page load if an active container is already set
  const initialContainers = document.querySelectorAll(".image-text-container.active");
  for ( let i = 0; i < initialContainers.length; i++ ) {
    const initialContainer = initialContainers[i];
    locationsSlider(initialContainer);
  }
}

// Locations Slider
function locationsSlider(container) {
  const thumbSlider = container.querySelector('.locations-thumb-swiper');
  const mainSlider = container.querySelector('.locations-main-swiper');

  if (thumbSlider && mainSlider) {
    // existing Swipers if already initialized
    if (thumbSlider.swiper) thumbSlider.swiper.destroy(true, true);
    if (mainSlider.swiper) mainSlider.swiper.destroy(true, true);

    // Init thumb slider
    const thumbsSwiper = new Swiper(thumbSlider, {
      spaceBetween: 10,
      slidesPerView: 3,
      freeMode: true,
      watchSlidesProgress: true,
      breakpoints: {
        768: {
          slidesPerView: 4,
        },
      },
    });

    // Init main slider
    const mainSwiper = new Swiper(mainSlider, {
      spaceBetween: 10,
      navigation: {
        nextEl: container.querySelector('.swiper-button-next'),
        prevEl: container.querySelector('.swiper-button-prev'),
      },
      thumbs: {
        swiper: thumbsSwiper,
      },
    });

    // Handle active thumb overlays
    mainSwiper.on('slideChange', () => {
      const activeIndex = mainSwiper.activeIndex;

      thumbsSwiper.slides.forEach(slide => {
        const overlay = slide.querySelector('.overlay');
        if (overlay) overlay.classList.add('active');
      });

      const activeThumb = thumbsSwiper.slides[activeIndex];
      if (activeThumb) {
        const overlay = activeThumb.querySelector('.overlay');
        if (overlay) overlay.classList.remove('active');
      }
    });

    // Run once on init
    mainSwiper.emit('slideChange');
  }
}

// Location Section
function LocationsSection() {
  const SectionMethods = {
    init: function () {
      // console.log("init")
      const sections = document.querySelectorAll(".location-container")
      sections.forEach(section => {
        const sectionId = section.dataset.locationsId
        const selectedSection = `.location-container-${sectionId}`

        const querySelectedSection = document.querySelector(selectedSection)

        if (querySelectedSection != null) {
          querySelectedSection.addEventListener("click", this.clickHandler)
        }
      })
    },

    clickHandler: function (event) {
      const aTag = event.target.closest(".nav-container a")

      if (aTag) {

        //Logic for removing underline and adding underline to active location
        const navContainer = aTag.closest(".nav-container")

        if (navContainer) {
          const aTags = navContainer.querySelectorAll("a")

          if (aTags.length > 0) {
            aTags.forEach(tag => {
              tag.classList.remove("active")
            })

            aTag.classList.add("active")
          }
        }

        //Logic for showing and now showing the correct container and information
        const linkIndex = aTag.dataset.index
        const infoContainers = document.querySelectorAll(".image-text-container");

        // run locationsSlider when container is active
        infoContainers.forEach(container => {
          const containerIndex = container.dataset.index;

          if (containerIndex == linkIndex) {
            container.classList.add("active");
            locationsSlider(container);
          } else {
            container.classList.remove("active");
          }
        });

        infoContainers.forEach(container => {
          const containerIndex = container.dataset.index

          if (containerIndex == linkIndex) {
            container.classList.add("active")
            let blockHandle = container.getAttribute('data-location');
            let urlHandle = aTag.getAttribute('data-info');
            let urlTitle = container.getAttribute('data-location-seo');

            window.history.replaceState("", "", '/pages/showroom-locations/' + blockHandle);
          } else {
            container.classList.remove("active")
          }
        })

        //Logic for syncing up teams with location
        const locationContainers = document.querySelectorAll(".location-container")
        const aTagText = aTag.dataset.info

        if (locationContainers.length > 0) {
          locationContainers.forEach(container => {
            const locationLocation = container.dataset.location

            if (locationLocation == aTagText) {
              container.classList.add("active")
            } else {
              container.classList.remove("active")
            }
          })
        }

        //Logic for syncing hero images with location
        const heroContainers = document.querySelectorAll(".location-hero-container")

        for (let i = 0; heroContainers.length > i; i++) {
          const container = heroContainers[i]

          if (container) {
            const heroLocation = container.dataset.location

            if (heroLocation == aTagText) {
              container.classList.add("active")
            } else {
              container.classList.remove('active')
            }
          }
        }
      }
    },
  }

  SectionMethods.init()

  return SectionMethods
}